import { ChevronLeft, ChevronRight, Maximize, X } from "lucide-react";
import { SECTIONS, useDeck } from "../../lib/deck-context";

export const PresentControls = ({ onExit }) => {
  const { idx, prev, next } = useDeck();
  return (
    <>
      <div className="fixed top-0 left-0 right-0 z-40 h-[3px] bg-line/60">
        <div data-testid="present-progress-bar" className="h-full bg-arq transition-[width] duration-500" style={{ width: `${((idx + 1) / SECTIONS.length) * 100}%` }} />
      </div>
      <div data-testid="present-controls" className="fixed bottom-6 left-1/2 -translate-x-1/2 z-40 flex items-center gap-1 rounded-full bg-ink-deep/90 backdrop-blur-xl px-2 py-2 text-white shadow-2xl opacity-40 hover:opacity-100 transition-opacity duration-300">
        <button data-testid="present-prev-btn" onClick={prev} disabled={idx === 0} className="h-9 w-9 grid place-items-center rounded-full hover:bg-white/10 disabled:opacity-30"><ChevronLeft size={18} /></button>
        <div data-testid="present-counter" className="px-4 text-sm whitespace-nowrap">
          <span className="font-mono text-arq-mid mr-2">{SECTIONS[idx].num}</span>
          <span className="hidden sm:inline">{SECTIONS[idx].label}</span>
          <span className="ml-3 font-mono text-xs text-white/40">{idx + 1}/{SECTIONS.length}</span>
        </div>
        <button data-testid="present-next-btn" onClick={next} disabled={idx === SECTIONS.length - 1} className="h-9 w-9 grid place-items-center rounded-full hover:bg-white/10 disabled:opacity-30"><ChevronRight size={18} /></button>
        <span className="mx-1 h-5 w-px bg-white/15" />
        <button data-testid="present-fullscreen-btn" onClick={() => (document.fullscreenElement ? document.exitFullscreen() : document.documentElement.requestFullscreen?.().catch(() => {}))} className="h-9 w-9 grid place-items-center rounded-full hover:bg-white/10"><Maximize size={15} /></button>
        <button data-testid="present-exit-btn" onClick={onExit} className="h-9 w-9 grid place-items-center rounded-full hover:bg-white/10"><X size={16} /></button>
      </div>
    </>
  );
};
